/**
 * Address popover component
 *
 * @version
 * 4.71.0 OAUI-694 Final UI tweaks and finishing touches
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2024 Build Centrix
 */
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { IAddressModel } from '../../../interfaces/orders/order-interfaces';

@Component({
  selector: 'app-popover-address',
  templateUrl: './address-popover.component.html',
  styleUrls: ['./address-popover.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AddressPopoverComponent {
  // Address details
  @Input() address: IAddressModel;
}
